"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureHeight = exports.use100vh = exports.setFontColor = exports.parse = exports.merge = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_1 = require("react");
var merge = function (first, second) {
    return merge_1.default({}, first, second);
};
exports.merge = merge;
var parse = function (text) {
    return html_react_parser_1.default(text || '', { trim: true });
};
exports.parse = parse;
var setFontColor = function (dark, color, theme, as) {
    if (dark !== undefined)
        return dark ? theme.fontColorOnDark : theme.fontColorOnLight;
    if (color)
        return color === 'primary' ? theme.primary : color;
    if (theme.fontColorTitle && (as === null || as === void 0 ? void 0 : as.includes('h')))
        return theme.fontColorTitle;
    if (theme.fontColor)
        return theme === null || theme === void 0 ? void 0 : theme.fontColor;
};
exports.setFontColor = setFontColor;
var use100vh = function () {
    var _a = react_1.useState(measureHeight), height = _a[0], setHeight = _a[1];
    var wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
    react_1.useEffect(function () {
        if (!wasRenderedOnClientAtLeastOnce)
            return;
        function setMeasuredHeight() {
            var measuredHeight = measureHeight();
            setHeight(measuredHeight);
        }
        window.addEventListener('resize', setMeasuredHeight);
        return function () { return window.removeEventListener('resize', setMeasuredHeight); };
    }, [wasRenderedOnClientAtLeastOnce]);
    return wasRenderedOnClientAtLeastOnce ? height : null;
};
exports.use100vh = use100vh;
function measureHeight() {
    var _a;
    if (!isClient())
        return null;
    return window.innerHeight || ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight);
}
exports.measureHeight = measureHeight;
function isClient() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function useWasRenderedOnClientAtLeastOnce() {
    var _a = react_1.useState(false), wasRenderedOnClientAtLeastOnce = _a[0], setWasRenderedOnClientAtLeastOnce = _a[1];
    react_1.useEffect(function () {
        if (isClient()) {
            setWasRenderedOnClientAtLeastOnce(true);
        }
    }, []);
    return wasRenderedOnClientAtLeastOnce;
}
//# sourceMappingURL=helpers.js.map